import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SvgIcon from "../SvgIcon.vue";

interface Props {
    alignCenter?: boolean;
    isLoading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    alignCenter: { type: Boolean },
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader", { center: _ctx.alignCenter }])
  }, [
    _createVNode(SvgIcon, {
      icon: "loader",
      class: _normalizeClass({ 'icon-spin': _ctx.isLoading })
    }, null, 8, ["class"])
  ], 2))
}
}

})